namespace Seac.Commons {
	export abstract class BaseListPage<TPageConfiguration extends object> extends Seac.Commons.BasePage<TPageConfiguration> {
		public init(): void {
			super.init();
			// controllo l'evento keyDown sugli input dei filtri e nel caso si tratti di un `Enter` eseguo il filtro
			$(document).delegate('.filter-control', Seac.Commons.Constants.keyDownEvent, (event: JQuery.KeyDownEvent) => {
				if (event.keyCode === Seac.Commons.KeyboardKeys.Enter) {
					// Controllo se si tratta di un input text DevExpress, imposto immediatamente il testo
					if (event && event.currentTarget && $(event.currentTarget).hasClass(Seac.Commons.Constants.DevExpress.dxTextBoxElement)) {
						const jTextBox = $(event.currentTarget);
						// Controllo vi sia un solo elemento
						if (jTextBox.length == 1) {
							try {
								jTextBox.dxTextBox(Seac.Commons.Constants.DevExpress.dxInstance)
									.option(Seac.Commons.Constants.DevExpress.dxValue, $(event.target).val())
								;
							}catch {
								// Se non è una textBox ignoro l'eccezione e continuo
							}
						}
					}
					this.filter();
				}
			});
        }

		/**
		 * Effettua il filtro sulla lista della pagina.
		 * Cancella eventuali errori in pagina.
		 * */
		protected filter(): void {
			Seac.Commons.notificationManager.clearNotifications();
			$('[data-toggle="tooltip"]').each((index, element) => {
				$(element).tooltip(Seac.Commons.Constants.Bootstrap.tooltipHide);
			});
		}

		/**
		 * Salva i filtri, in modo che vengano ricaricati al successivo ingresso nella pagina
		 * @param gridId ID univoco della griglia a cui appartengono i filtri
		 * @param ignoreImpresa Indica se salvare il filtro come generico, anziché assegnato all'impresa corrente
		 * @returns Filtri salvati per la pagina
		 */
		protected saveFilterControlsValue(gridId: string, ignoreImpresa: boolean = false): Array<Seac.Services.GridFilters> {
			return Seac.Services.gridFilterPersistenceService.saveFilterControlsValue(gridId, ignoreImpresa);
		}

		/**
		 * Ricarica i filtri salvati in precedenza
		 * @param gridId ID univoco della griglia a cui appartengono i filtri
		 * @param normalize Funzione facoltativa di normalizzazione del dato letto. Viene utilizzata per modificare il valore del filtro letto, per esempio per convertire le date da stringa a Data oppure per recuperare l'effettivo item da una selectbox.
		 * @param ignoreImpresa Indica se leggere il filtro come generico, anziché assegnato all'impresa corrente
		 */
		protected restoreFilterControlsValue(gridId: string, normalize: Seac.Services.GridFiltersValueNormalize = null, ignoreImpresa: boolean = false): Array<Seac.Services.GridFiltersValue> | null {
			return Seac.Services.gridFilterPersistenceService.restoreFilterControlsValue(gridId, normalize, ignoreImpresa);
		}

		/** Ripristina il valore di un singolo elemento del filtro */
		public restoreFilterControlsOriginalValue(element: HTMLElement | JQuery<HTMLElement> | DevExpress.ui.Widget, checkBeforeElementList: Array<HTMLElement | JQuery<HTMLElement> | DevExpress.ui.Widget> = null): any | null {
			// Controllo che gli elementi precedenti siano coerenti
			if (checkBeforeElementList) {
				for (let checkBeforeElementIndex = 0; checkBeforeElementIndex < checkBeforeElementList.length; checkBeforeElementIndex++) {
					let elementToCkeck	: HTMLElement | JQuery<HTMLElement> | DevExpress.ui.Widget = checkBeforeElementList[checkBeforeElementIndex];
					let jElementToCkeck	: JQuery;
					// Controllo la tipologia dell'elemento
					if ((<DevExpress.ui.Widget>elementToCkeck).element) {
						jElementToCkeck = $((<DevExpress.ui.Widget>elementToCkeck).element());
					}else {
						jElementToCkeck = $(<any>elementToCkeck);
					}

					if (!Seac.Services.gridFilterPersistenceService.hasFilterOriginalValue(jElementToCkeck)) {
						return null;
					}
				}
			}

			if ((<DevExpress.ui.Widget>element).element) {
				return Seac.Services.gridFilterPersistenceService.restoreFilterControlsOriginalValue($((<DevExpress.ui.Widget>element).element()));
			}else {
				return Seac.Services.gridFilterPersistenceService.restoreFilterControlsOriginalValue($(<any>element));
			}
		}

		/**
		 * Prepara la pagina per la stampa, rimuovendo tutto ciò che non serve per la stampa.
		 * La bassa laterale viene nascosta
		 * Gli oggetti con classe hide-in-print vengono nascosti
		 * Gli oggetti con classe show-in-print vengono visualizzati
		 * Ritorna un oggetto con la configurazione da utilizzare per la funzione prentRestorePagePost
		 */
		protected printPreparePageFor(): PreChangePageConfiguration {
			// Leggo la configurazione della pagina
			const leftMenuOpen: boolean	= Seac.Components.topMenuComponent.leftMenuIsOpen;
			const hideInPrintObjects: JQuery = $('.hide-in-print').not(':hidden');
			const showInPrintObjects: JQuery = $('.show-in-print:hidden');

			// Nascondo / visualizzo gli oggetti per la stampa
			Seac.Components.topMenuComponent.leftMenuIsOpen = false;
			hideInPrintObjects.hide();
			showInPrintObjects.show();

			return new PreChangePageConfiguration(
				leftMenuOpen,
				hideInPrintObjects,
				showInPrintObjects
			);
		}
		/**
		 * Ripristina la configurazione della pagina dopo la stampa
		 * @param prePrintConfig Configurazione pre stampa ottenuta dalla funzione printPeparePageFor
		 */
		protected printRestorePagePost(prePrintConfig: PreChangePageConfiguration): void {
			// Ripristino la configurazione della pagina
			Seac.Components.topMenuComponent.leftMenuIsOpen = prePrintConfig.leftMenuOpened;
			prePrintConfig.hidObjects.show();
			prePrintConfig.showedObjects.hide();
		}

		/**
		 * Stabilisce se una griglia ha filtri salvati nei cookie
		 * @param gridId ID univoco della griglia a cui appartengono i filtri
		 * @param normalize Funzione facoltativa di normalizzazione del dato letto. Viene utilizzata per modificare il valore del filtro letto, per esempio per convertire le date da stringa a Data oppure per recuperare l'effettivo item da una selectbox.
		 */
		protected haveFilterControlsValue(gridId: string, normalize: Seac.Services.GridFiltersValueNormalize = null): boolean{
			return Seac.Services.gridFilterPersistenceService.haveFilterControlsValue(gridId, normalize);
		}
    }
}
